import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var AerospaceEng = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.204 28.878a6.815 6.815 0 0 0-9.7 0c-.8.801-1.3 1.902-1.6 3.104-.4 1.201-.6 2.503-.8 3.704-.2 1.202-.3 2.403-.3 3.204-.1 2.002.4 2.503 2.4 2.403.9 0 2-.2 3.2-.3 1.2-.2 2.6-.401 3.7-.802 1.2-.4 2.3-.9 3.1-1.601 2.7-2.704 2.7-7.109 0-9.712Zm-1.4 8.21c-.4.4-1.1.8-2.2 1.101-1 .3-2.2.6-3.4.701-1.2.2-2.3.3-3.1.3-.2 0-.2 0-.2-.2.1-.8.2-1.902.3-3.104.1-1.201.4-2.402.7-3.404.3-1.1.7-1.802 1.1-2.202 1.9-1.902 4.9-1.902 6.7 0 1.8 1.902 1.9 4.906.1 6.808Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.704 1.146c-.1-.4-.4-.701-.8-.801-2.6-.701-5.7-.3-8.8.9a27.329 27.329 0 0 0-9.1 6.208l-.9.901-11 .801c-.2 0-.5.1-.7.3L.304 21.47c-.3.3-.4.8-.2 1.1.2.401.5.602 1 .602h10.2l9.5 9.51v10.213c0 .4.2.8.6 1 .4.201.9.1 1.1-.2l12.1-12.114c.2-.2.3-.4.3-.7l.8-11.013.9-.901c2.8-2.804 4.9-6.007 6.1-9.111 1.3-3.004 1.6-6.107 1-8.71Zm-40.1 20.023 10.1-10.112 8.2-.6-10.7 10.812-7.6-.1Zm29.4 9.211-10.1 10.112v-7.61l10.7-10.712-.6 8.21Zm7.8-21.225c-.9 2.403-2.5 4.906-4.5 7.209-.6.7-1.6 1.601-2.3 2.302l-12.2 12.315-8.7-8.71 13.4-13.416c2.5-2.503 5.2-4.305 7.9-5.507 2.5-1.1 5.3-1.501 7.4-1.201.3 2.102 0 4.505-1 7.008Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M32.204 15.362c1.933 0 3.5-1.568 3.5-3.504a3.502 3.502 0 0 0-3.5-3.504 3.502 3.502 0 0 0-3.5 3.504 3.502 3.502 0 0 0 3.5 3.504Z"
  })));
});
AerospaceEng.displayName = 'AerospaceEng';
AerospaceEng.defaultProps = {
  'aria-label': 'AerospaceEng'
};
export default AerospaceEng;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/AerospaceEng.js
// module id = 3596
// module chunks = 11